import React from 'react';
import { Text, type TextT } from '@mentimeter/ragnar-ui/text';
import { LinkIcon } from '@mentimeter/ragnar-visuals';
import { slugify } from '../../utils/slugify';
import { getTextContentFrom } from '../../utils/getTextContentFrom';
import { Link } from '../Wrapper/Link';

export interface HeadingT extends TextT {
  useAnchors?: boolean;
}

export const Heading = (props: HeadingT) => {
  const { children, useAnchors } = props;
  if (!children) {
    return null;
  }

  const id = slugify(getTextContentFrom(children));

  const generalStyles: TextT = {
    as: 'h2',
    color: 'text',
    fontFamily: 'heading',
    lineHeight: 'heading',
    fontSize: [5, 6, 7],
    mb: ['space2', null, 'space4'],
  };

  if (useAnchors) {
    return (
      <Text
        {...generalStyles}
        id={id}
        extend={() => ({
          scrollMarginTop: '130px',
          '> .heading-anchor': {
            display: 'none',
          },
          ':hover': {
            '> .heading-anchor': {
              display: 'initial',
            },
          },
        })}
        {...props}
      >
        {children}
        <Link
          lineHeight="none"
          underline={false}
          aria-hidden="true"
          className="heading-anchor"
          href={`#${id}`}
          mx="space2"
        >
          <LinkIcon size={16} />
        </Link>
      </Text>
    );
  }

  return (
    <Text
      {...generalStyles}
      id={id}
      extend={() => ({ scrollMarginTop: '130px' })}
      {...props}
    />
  );
};
